"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _memoizeOne = _interopRequireDefault(require("memoize-one"));
var _exchangeSearchCommon = require("@mulesoft/exchange-search-common");
var _exchangeClientsCommons = require("@mulesoft/exchange-clients-commons");
var _utils = require("../utils");
var _filters = require("./filters");
var constants = _interopRequireWildcard(require("../../constants"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const addFilterIf = (condition, property) => condition ? [property] : [];
const loadingFilter = [{
  '@type': 'gui:CustomFilter',
  'gui:target': '',
  'gui:main': true,
  'gui:range': {
    '@id': 'Loading'
  }
}];
const getBoost = (boostConfiguration = []) => [{
  'gui:target': 'assets.AssetNode.name',
  'gui:value': 10
}, {
  'gui:target': 'assets.AssetNode.description',
  'gui:value': 2
}, {
  'gui:target': 'customer-metadata.CustomerMetadataNode.searchableValues',
  'gui:value': 4
}, {
  'gui:target': 'customer-metadata.CustomerMetadataNode.tags',
  'gui:value': 4
}].concat(boostConfiguration.filter(boost => boost).map(boost => {
  return {
    'gui:target': boost.target,
    'gui:value': boost.value
  };
}));
const sortingOptions = {
  score: {
    label: 'Relevance'
  },
  featured: {
    label: 'Featured',
    fields: [{
      field: 'assets.AssetNode.ranking',
      order: 'asc'
    }, {
      field: 'asset-minor-versions.MinorVersionNode.updatedAt',
      order: 'desc'
    }]
  },
  name: {
    label: 'Name',
    fields: [{
      field: 'k:assets.AssetNode.name',
      order: 'asc'
    }]
  },
  last: {
    label: 'Last modified',
    fields: [{
      field: 'asset-minor-versions.MinorVersionNode.updatedAt',
      order: 'desc'
    }]
  },
  rating: {
    label: 'Rating',
    fields: [{
      field: 'asset-minor-versions.MinorVersionNode.averageRating',
      order: 'desc'
    }]
  }
};
const getConfig = (assetTypesConfiguration, config, profile, context, featureFlags, maxANGSearchResults, fixedTypes, fixedStatuses, facets, filters, angQuery, updateFilter, boostConfiguration, sort) => {
  var _sortingOptions$sort;
  const targetPathName = '/api/v2/ang/stream';
  const fixedAssetTypesFilter = (fixedTypes === null || fixedTypes === void 0 ? void 0 : fixedTypes.length) > 0 ? (0, _filters.getAssetTypesFilter)({
    assetTypesConfiguration,
    featureFlags,
    types: (0, _exchangeSearchCommon.getANGTypes)(fixedTypes, assetTypesConfiguration)
  }).map(type => type.k) : (0, _utils.getAllANGTypes)(assetTypesConfiguration, featureFlags);
  const isAuthenticated = !!profile;
  const categoriesFilter = (0, _filters.getCategoriesFilter)(facets === null || facets === void 0 ? void 0 : facets.categories);
  const tagsFilter = (0, _filters.getTagsFilter)(facets === null || facets === void 0 ? void 0 : facets.tags);
  const organizationsFilter = (0, _filters.getOrganizationsFilter)(facets === null || facets === void 0 ? void 0 : facets.organizations, config, profile, angQuery);
  const assetTypesFilter = (0, _filters.getAssetTypesFilter)({
    assetTypesConfiguration,
    featureFlags,
    types: facets === null || facets === void 0 ? void 0 : facets.types,
    fixedTypes
  });
  const statusesFilter = (0, _filters.getStatusesFilter)(facets === null || facets === void 0 ? void 0 : facets.status);
  const initialFilters = (filters === null || filters === void 0 ? void 0 : filters.length) > 0 ? loadingFilter : [];
  const angConfig = _objectSpread(_objectSpread({
    '@context': {
      gui: 'http://anypoint.com/vocabs/ang-gui#',
      xsd: 'http://www.w3.org/2001/XMLSchema#' // NOSONAR
    },
    '@type': 'gui:SearchConfiguration',
    'gui:size': {
      'gui:variable': '_size',
      'gui:value': maxANGSearchResults !== null && maxANGSearchResults !== void 0 ? maxANGSearchResults : constants.MAX_ANG_STREAM_SEARCH_RESULTS
    },
    'gui:container': {
      '@type': 'gui:ContainerNode',
      'gui:target': (0, _exchangeClientsCommons.getAPIUrl)({
        service: config.api,
        context,
        pathname: targetPathName
      }),
      'gui:variable': 'q'
    },
    'gui:streamed': true,
    'gui:groups': [{
      '@type': 'gui:Group',
      'gui:label': 'Main',
      'gui:main': true,
      'gui:properties': [...(filters !== null && filters !== void 0 ? filters : []).reduce((accum, current) => {
        if (current === 'types' && assetTypesFilter.length > 0) {
          return [...accum, {
            '@type': 'gui:SearchableProperty',
            'gui:target': 'assets.@type',
            'gui:label': 'Asset Type',
            'gui:main': true,
            'gui:multi': true,
            'gui:singular': 'type',
            'gui:plural': 'types',
            'gui:range': {
              '@id': 'xsd:string'
            },
            'gui:values': assetTypesFilter
          }];
        }
        if (current === 'organizations' && organizationsFilter.length > 0) {
          return [...accum, {
            '@type': 'gui:SearchableProperty',
            'gui:target': 'assets.AssetNode.organizationId',
            'gui:label': 'Organization',
            'gui:main': true,
            'gui:multi': true,
            'gui:searchable': true,
            'gui:singular': 'organization',
            'gui:plural': 'organizations',
            'gui:range': {
              '@id': 'xsd:string'
            },
            'gui:values': organizationsFilter
          }];
        }
        if (current === 'categories' && (categoriesFilter.length > 0 || facets !== null && facets !== void 0 && facets.hasCategoriesFilter)) {
          return [...accum, {
            '@type': 'gui:SearchableProperty',
            'gui:target': 'customer-metadata.CustomerMetadataNode.categories',
            'gui:label': isAuthenticated ? 'Category' : 'Category/Industry',
            'gui:condition': 'AND',
            'gui:main': true,
            'gui:multi': true,
            'gui:searchable': true,
            'gui:searchFunction': facets !== null && facets !== void 0 && facets.hasCategoriesFilter ? updateFilter : null,
            'gui:searchFunctionDelay': constants.SEARCH_FUNCTION_DELAY,
            'gui:singular': isAuthenticated ? 'category' : 'category/industry',
            'gui:plural': isAuthenticated ? 'categories' : 'categories/industries',
            'gui:range': {
              '@id': 'xsd:string'
            },
            'gui:values': categoriesFilter
          }];
        }
        if (current === 'tags' && (tagsFilter.length > 0 || facets !== null && facets !== void 0 && facets.hasTagsFilter)) {
          return [...accum, {
            '@type': 'gui:SearchableProperty',
            'gui:target': 'customer-metadata.CustomerMetadataNode.tags',
            'gui:label': 'Tags',
            'gui:condition': 'AND',
            'gui:main': true,
            'gui:multi': true,
            'gui:searchable': true,
            'gui:searchFunction': facets !== null && facets !== void 0 && facets.hasTagsFilter ? updateFilter : null,
            'gui:searchFunctionDelay': constants.SEARCH_FUNCTION_DELAY,
            'gui:singular': 'tag',
            'gui:plural': 'tags',
            'gui:range': {
              '@id': 'xsd:string'
            },
            'gui:values': tagsFilter
          }];
        }
        if (current === 'statuses' && statusesFilter.length > 0) {
          return [...accum, {
            '@type': 'gui:SearchableProperty',
            'gui:target': 'asset-minor-versions.VersionNode.status',
            'gui:label': 'Lifecycle state',
            'gui:defaultValues': ['published', 'development', 'deprecated'],
            'gui:condition': 'OR',
            'gui:main': true,
            'gui:multi': true,
            'gui:searchable': false,
            'gui:searchFunction': null,
            'gui:searchFunctionDelay': null,
            'gui:singular': 'lifecycle state',
            'gui:plural': 'lifecycle states',
            'gui:range': {
              '@id': 'xsd:string'
            },
            'gui:values': statusesFilter
          }];
        }
        if (current === 'customFields') {
          return [...accum, {
            '@type': 'gui:CustomFilter',
            'gui:target': '',
            'gui:main': true,
            'gui:range': {
              '@id': 'CustomFieldsFilter'
            }
          }];
        }
        return accum;
      }, initialFilters), ...(isAuthenticated ? [{
        '@type': 'gui:SearchableProperty',
        'gui:target': 'sharedWithMe',
        'gui:visible': false,
        'gui:range': {
          '@id': 'xsd:bool'
        },
        'gui:defaultValues': []
      }] : [])]
    }, {
      '@type': 'gui:Group',
      'gui:label': 'Hidden',
      'gui:main': false,
      'gui:properties': [{
        '@type': 'gui:SearchableProperty',
        'gui:target': 'asset-minor-versions.VersionNode.generatedFrom',
        'gui:visible': false,
        'gui:range': {
          '@id': 'xsd:anyURI'
        },
        'gui:defaultValues': ['http://none']
      }, ...addFilterIf(!(filters !== null && filters !== void 0 && filters.includes('types')) && angQuery.type.length === 0 || assetTypesFilter.length === 0, {
        '@type': 'gui:SearchableProperty',
        'gui:target': 'assets.@type',
        'gui:visible': false,
        'gui:range': {
          '@id': 'xsd:string'
        },
        'gui:defaultValues': fixedAssetTypesFilter
      }), ...addFilterIf(!(filters !== null && filters !== void 0 && filters.includes('statuses')) && (fixedStatuses === null || fixedStatuses === void 0 ? void 0 : fixedStatuses.length) > 0, {
        '@type': 'gui:SearchableProperty',
        'gui:target': 'asset-minor-versions.VersionNode.status',
        'gui:visible': false,
        'gui:range': {
          '@id': 'xsd:string'
        },
        'gui:defaultValues': fixedStatuses
      })]
    }],
    'gui:boost': getBoost(boostConfiguration)
  }, (_sortingOptions$sort = sortingOptions[sort]) !== null && _sortingOptions$sort !== void 0 && _sortingOptions$sort.fields ? {
    'gui:sort': {
      'gui:variable': '_sort',
      'gui:ordering': sortingOptions[sort].fields.map(({
        field,
        order
      }) => ({
        'gui:field': field,
        'gui:order': order
      }))
    }
  } : {}), {}, {
    'gui:source': {
      'gui:variable': '_source',
      'gui:fields': ['assets.AssetNode.*', 'assets.FileNode.*', 'assets.@type', 'assets.@id', 'asset-major-versions.AssetMajorNode.*', 'asset-minor-versions.MinorVersionNode.*', 'asset-minor-versions.@id', 'asset-minor-versions.VersionNode.*', 'customer-metadata.CategoryNode.*', 'customer-metadata.CustomerMetadataNode.*', 'system-metadata.SystemMetadataNode.*']
    }
  });
  return angConfig;
};
var _default = exports.default = (0, _memoizeOne.default)(getConfig);
//# sourceMappingURL=config.js.map